import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function UtilityBillPayment() {
  const faqs = [
    {
      question: "What is Mokshiq BBPS Utility Bill Payment API?",
      answer: "Mokshiq BBPS Utility Bill Payment API (by Rakle Service Private Limited) connects your platform directly to Bharat Bill Payment System (BBPS) nodes for instant electricity, gas, water, broadband, and landline bill processing."
    },
    {
      question: "Does it support real-time bill amount fetching?",
      answer: "Yes, our API automatically fetches the customer name, due date, and exact bill amount prior to payment confirmation."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-receipt me-2"></i>BBPS API Suite
            </span>
            <h1 className="page_title text-white mb-3">Utility Bill Payment API &amp; Software</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Bharat BillPay (BBPS) bill fetching and instant payment execution powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">API Solutions</a></li>
              <li className="active"><a href="#!">Utility Bill Payment</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-bolt text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Electricity Bill Payment</h3>
                  <p className="text-muted small">Coverage for state electricity boards across India with instant consumer number lookup.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-fire text-danger fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Piped Gas &amp; LPG Booking</h3>
                  <p className="text-muted small">Direct booking and bill payment for IGL, MGL, Gujarat Gas, Indane, Bharat Gas, and HP Gas.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-droplet text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Water &amp; Municipal Tax</h3>
                  <p className="text-muted small">Pay municipal water bills and local authority taxes with real-time digital receipts.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Utility Bill Payment FAQs" subtitle="Frequently asked questions about BBPS bill payment integration." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default UtilityBillPayment;
